// Packages:
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

// Styles:
import {
  Wrapper,
  Header,
  Title
} from './styles';

// Functions:
const ResourceCenter = (props) => {

  // Return:
  return (
    <Wrapper openCollapse={props.openCollapse}>
        <Header>
        <Title>Related Articles</Title>
      </Header>

      <Scrollbars style={{ width: '100%', height: 'calc(100% - 2.5rem)' }}>
      </Scrollbars>
    </Wrapper>
  );
};

// Exports:
export default ResourceCenter;
